module.exports = __webpack_public_path__ + "static/media/hydronomad-1.ef6115c8.jpg";